/**
 * Toggle overlay status
 * @param {object} state - The vuex state object
 * @return {Boolean} Boolean
 */
export const getToggleMobileNavStatus = (state) => {
  return state.toggleClass
};
